import React, { useEffect } from "react";
import { Card, Form, Avatar, Row, Col, Spin } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { useQuery } from "@tanstack/react-query";
import { getMyDetails } from "../services/api";
import PersonalDetailsForm from "../components/PersonalDetailsForm";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";

export default function Profile() {
  const accessToken = Cookies.get("token");
  const { data: userDetails } = useQuery({
    queryKey: ["myDetails"],
    queryFn: async () => {
      const response = await getMyDetails(accessToken);
      return response.data;
    },
    enabled: !!accessToken,
    refetchOnWindowFocus: false,
  });

  const [form] = Form.useForm();
  const navigate = useNavigate();

  useEffect(() => {
    if (!accessToken) {
      navigate(`/`);
    }
  }, [accessToken, navigate]);

  if (!userDetails) {
    return (
      <Row
        justify="center"
        align="middle"
        style={{ minHeight: "100vh", background: "#f5f5f5" }}
      >
        <Spin />
      </Row>
    );
  }

  return (
    <div style={{ height: "90vh", margin: "0" }}>
      <Row
        justify="center"
        align="middle"
        style={{
          padding: 16,
        }}
      >
        <Col xs={20} sm={20} md={16} lg={8} xl={8}>
          <Card
            styles={{
              width: "90%",
              borderRadius: 16,
              boxShadow: "0 18px 40px rgba(15, 23, 42, 0.18)",
              body: { padding: 24 },
            }}
          >
            <Row justify="center">
              <Col>
                <Avatar
                  size={96}
                  src={userDetails?.profileImage}
                  icon={!userDetails?.profileImage ? <UserOutlined /> : null}
                >
                  <UserOutlined />
                </Avatar>
              </Col>
            </Row>
            <div>
              <PersonalDetailsForm form={form} userDetails={userDetails} />
            </div>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
